import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

const InitialPasswordNotice = () => {
  const { t } = useTranslation();

  return (
    <div className="InitialPasswordNotice">
      {t('Initial password will be generated for a license user')}
    </div>
  );
};

export default InitialPasswordNotice;
